import React from "react";
import "antd/dist/antd.css";
import Icon from "@ant-design/icons";

function CompanyAvatarIcon() {
  const BuildingSvg = () => (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        {" "}
        <path
          id="fi-rr-building"
          d="M7,14a1,1,0,0,1-1,1H5a1,1,0,0,1,0-2H6A1,1,0,0,1,7,14Zm4-1H10a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2ZM6,17H5a1,1,0,0,0,0,2H6a1,1,0,0,0,0-2Zm5,0H10a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2ZM6,5H5A1,1,0,0,0,5,7H6A1,1,0,0,0,6,5Zm5,0H10a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2ZM6,9H5a1,1,0,0,0,0,2H6A1,1,0,0,0,6,9Zm5,0H10a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm13,1v9a5.006,5.006,0,0,1-5,5H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0h6a5.006,5.006,0,0,1,5,5h3a5.006,5.006,0,0,1,5,5ZM5,22h9V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3ZM22,10a3,3,0,0,0-3-3H16V22h3a3,3,0,0,0,3-3Zm-3,3a1,1,0,1,0,1,1A1,1,0,0,0,19,13Zm0,4a1,1,0,1,0,1,1A1,1,0,0,0,19,17Zm0-8a1,1,0,1,0,1,1A1,1,0,0,0,19,9Z"
          fill="#babec4"
        />{" "}
      </svg>
    </>
  );

  const HeartIcon = (props) => <Icon component={BuildingSvg} {...props} />;

  return (
    <>
      <HeartIcon style={{ color: "white" }} />
    </>
  );
}

export default CompanyAvatarIcon;
